var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M320 219.045h-42.667L256 182.094l-21.333 36.95H192l21.335 36.951L192 292.944h42.667L256 329.895l21.333-36.95H320l-21.335-36.951L320 219.045zm-37.791 36.949l-13.104 22.699h-26.209l-13.105-22.699 13.105-22.699h26.209l13.104 22.699zM256 210.597l4.877 8.448h-9.754l4.877-8.448zm-39.315 22.698h9.755l-4.877 8.448-4.878-8.448zm0 45.399l4.877-8.448 4.877 8.448h-9.754zM256 301.392l-4.876-8.448h9.754L256 301.392zm39.315-22.698h-9.755l4.877-8.448 4.878 8.448zm-9.755-45.399h9.755l-4.877 8.448-4.878-8.448zM0 106.657h512v42.663H0zm0 256h512v42.663H0z",
  fill: "#2e52b2"
})));

export default SvgIl;